enum AddressType {
  PHYSICAL = 1,
  MAILING = 2,
  OFFICE = 3,
  HOME = 4,
}

export default AddressType;



// WEBPACK FOOTER //
// ./src/models/address-type.ts